<template>
  <div>
    <va-modal
      ref="createOrUpdateAudProviderForwardinRuleModal"
      :value="isOpen"
      :noOutsideDismiss="true"
      :okText="$t('modals.buttons.save')"
      :cancelText="$t('modals.buttons.cancel')"
      size="large"
      @ok="submitForm"
      @cancel="onCancel"
      :okDisabled="addedCriterias.length === 0 || form.name === null || form.name === '' || isSubmitting"
    >
      <div slot="header" class="modal-title">
        <span>{{ $t('entities.entity_aud_provider_forwarding_rules.create_new_rule') }}</span>
      </div>

      <div class="row">
        <div class="col-6">
          <va-input
            id="name"
            v-model="form.name"
            :label="$t('users.inputs.name')"
            :placeholder="$t('users.inputs.name')"
            :maxlength=64
          />
        </div>
      </div>
      <div class="mt-4 ml-2 mr-2">
        <h5> {{$t('entities.entity_aud_provider_forwarding_rules.criterias_title')}}</h5>

        <div class="row">
          <div class="col-4">
            <label class="form-label">{{ $t('entities.entity_aud_provider_forwarding_rules.criterias.lead_field') }}</label>
            <multiselect
              :options="leadFields"
              id="client"
              v-model="form.lead_field"
              label="name"
              track-by="id"
              :placeholder="$t('entities.entity_aud_provider_forwarding_rules.criterias.lead_field')"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>

          </div>

          <div class="col-4">
            <label class="form-label">{{ $t('entities.entity_aud_provider_forwarding_rules.criterias.comparator') }}</label>
            <multiselect
              :options="filteredComparators"
              id="client"
              v-model="form.comparator"
              label="comparator"
              track-by="id"
              :placeholder="$t('entities.entity_aud_provider_forwarding_rules.criterias.comparator')"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              :disabled="!form.lead_field"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>

          </div>

          <div class="col-3">
            <label class="form-label">{{ $t('entities.entity_aud_provider_forwarding_rules.criterias.value') }}</label>
            <va-input
              :disabled="form.lead_field ? form.lead_field.valueDisabled : true"
              id="name"
              v-model="form.value"
              :placeholder="$t('entities.entity_aud_provider_forwarding_rules.criterias.value')"
              :maxlength=16
            />
          </div>

          <div class="col-1 d-flex flex-column justify-content-center">
            <i class="fa fa-plus-circle clickable" @click="handleAddNewCriteria" style="font-size: 30px">
            </i>
          </div>
        </div>

        <div>
          <div class="row d-flex justify-content-center mt-5">
            <h5 v-if="addedCriterias.length === 0"> {{$t('entities.entity_aud_provider_forwarding_rules.no_criterias_defined')}} </h5>
            <div v-else class="w-100">
              <h5 class="is-bold"> {{ $t('entities.entity_aud_provider_forwarding_rules.criterias_list') }} </h5>
              <table>
                <thead>
                <tr>
                  <th> {{$t('entities.entity_aud_provider_forwarding_rules.criterias.lead_field')}}</th>
                  <th> {{ $t('entities.entity_aud_provider_forwarding_rules.criterias.comparator') }}</th>
                  <th> {{ $t('entities.entity_aud_provider_forwarding_rules.criterias.value') }}</th>
                  <th> {{ $t('reports.templates.table.actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(crit, idx) in addedCriterias">
                  <td> {{ crit.lead_field }}</td>
                  <td> {{ crit.comparator }}</td>
                  <td> {{ crit.value ? crit.value : 'N/A' }}</td>
                  <td><i class="fa fa-trash clickable" @click="handleRemoveCriteria(idx)"></i></td>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>



    </va-modal>
  </div>

</template>

<script>
import Multiselect from 'vue-multiselect';
import { LeadsService } from '@/api/LeadsService';

export default {
  components: { Multiselect },
  props: {
    audProviderId: {
      type: Number,
      required: true
    },
    entityId: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      isOpen: false,
      isSubmitting: false,
      leadFields: [
        {id: 1, name: 'questionnaire', allowedComparators: [ {id: 1, comparator: 'notEmpty'}], valueDisabled: true},
        {id: 2, name: 'phone', allowedComparators: [ {id: 1, comparator: 'notNull'}], valueDisabled: true},
        {id: 3, name: 'email', allowedComparators: [{id: 1, comparator: 'notNull'}], valueDisabled: true},
        {id: 4, name: 'hearingTest', allowedComparators: [{id: 1, comparator: 'notNull'}], valueDisabled: true},
        {id: 5, name: 'hearing_loss', allowedComparators: [
          {id: 1, comparator: '>='},
            {id: 2, comparator: '<='},
            {id: 3, comparator: '>'},
            {id: 4, comparator: '<'},
            {id: 5, comparator: '==='},
            {id: 6, comparator: '!=='}],
          valueDisabled: false},
      ],
      addedCriterias: [],
      form: {
        name: null,
        lead_field: null,
        comparator: null,
        value: null
      }
    }

  },
  mounted: function () {
    this.isOpen = true
  },
  methods:  {
    handleAddNewCriteria() {
      if(this.form.lead_field && this.form.comparator) {
        if(this.form.lead_field.valueDisabled || (!this.form.lead_field.valueDisabled && this.form.value)) {
          this.addedCriterias.push({
            lead_field: this.form.lead_field.name,
            comparator: this.form.comparator.comparator,
            value: this.form.value
          })
        }
      }
    },
    handleRemoveCriteria(criteriaIdx) {
      this.addedCriterias.splice(criteriaIdx, 1)
    },
    async submitForm() {
      this.isSubmitting = true
      let data = {}
      data.entity_id = this.entityId
      data.aud_provider_id = this.audProviderId
      data.name = this.form.name
      data.criterias = this.addedCriterias

      try {
        let responseData = await LeadsService.createRule(data)
        this.$emit('created', responseData)
        setTimeout(() => {
          this.showToast(this.$t('entities.entity_aud_provider_forwarding_rules.created_success'), this.$store.state.successToastOptions)

          this.showModal = false
        }, 250)
      } catch (error) {
        console.log(error)
        this.showModal = false
        setTimeout(() => {
          this.showToast(this.$t('references.errors.server'), this.$store.state.errorToastOptions)
          this.$emit('canceled')
        }, 250)
      }

    },
    onCancel() {
      this.showModal = false
      setTimeout(() => {
        this.$emit('canceled')
      }, 250)
    }
  },
  computed: {
    filteredComparators: function() {
      if(this.form.lead_field) {
        return this.form.lead_field.allowedComparators
      }
      return []
    }
  }
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
}

th,
td {
  padding: 15px;
  background-color: rgba(183, 223, 198, 0.55);
  color: #464646;
}

th {
  text-align: center;
  font-weight: bold;
}

thead {
  th {
    background-color: #79c09c;
  }
}

tbody {
  tr {
    &:hover {
      background-color: rgba(255, 255, 255, 0.3);
    }
  }

  td {
    position: relative;
    text-align: center;

    &:hover {
      &:before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: -9999px;
        bottom: -9999px;
        background-color: rgba(255, 255, 255, 0.2);
        z-index: -1;
      }
    }
  }
}

</style>
